<template>
  <div id="app">
    <div class="wrapper">
      <Header />
      <!--<Sidebar />-->
      <loading
        :active.sync="$wait.any"
        :can-cancel="false"
        :is-full-page="true"
      />
      <router-view
        :key="$route.fullPath"
        style="overflow-x: hidden;"
        class="main-font-style"
      />
      <Footer class="main-font-style" />
    </div>
  </div>
</template>

<script>
import Header from '@/components/organisms/OrHeader'
// import Sidebar from '@/components/organisms/OrSidebar'
import Footer from '@/components/organisms/OrFooter'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Loading
    // Sidebar
  },
  data () {
    return {
      user_token: localStorage.getItem('fs_token'),
      user_id: localStorage.getItem('fs_user_id')
    }
  },
  computed: {
    user () {
      if (this.$store.state.Auth.user || this.user_token) return true
      return false
      /* if (localStorage.getItem('token') === '1') {
        return true
      }
      if (this.$store.state.Auth.user) {
        return true
      }
      return false */
    }
  },
  beforeCreate () {
    window.toasted = this.$toasted
    window.wait = this.$wait
  },
  created () {
    // if (this.user_id !== '9') this.$router.push({ name: 'M0002LandingPage' })
    /*
    this.$store.dispatch('Auth/initUser')
      .then(user => {
        this.user_token = localStorage.getItem('fs_token')
        if (!user) {
          localStorage.removeItem('fs_token')
          if (this.$route.name !== 'Login') this.$router.push('/Login')
        } else {
          if (this.$route.name === 'Login') {
            this.$router.push({name: 'Top'})
          }
        }
      })
      */
  }
}
</script>

<style>
label:not(.form-check-label):not(.custom-file-label) {
  font-weight: normal !important;
  line-height: normal !important;
}

.modal-xl {
  max-width: 1140px !important;
}

.modal-fullscreen .modal-dialog {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen .modal-content {
  min-height: 100vh !important;
}
span.badge {
  line-height: normal !important;
}
</style>
